<template>
  <section class="login-page">
    <div class="login-panel">
      <div class="brand">
        <span class="brand-mark">Q</span>
        <div>
          <strong>QQ Persona</strong>
          <small>Admin Console</small>
        </div>
      </div>
      <h1>管理后台登录</h1>
      <p v-if="auth.security" class="security-message" :class="{ locked: auth.security.locked }">
        {{ auth.security.message }}
      </p>
      <form v-if="!auth.security?.locked" @submit.prevent="submit">
        <p v-if="tokenMode" class="security-message">
          当前为 API token 模式。Token 仅保存在本页内存中，刷新后需要重新输入。
        </p>
        <label>{{ tokenMode ? "Admin Token" : "管理密码" }}</label>
        <input
          v-if="tokenMode"
          v-model="token"
          type="password"
          autocomplete="off"
          autofocus
        />
        <input
          v-else
          v-model="password"
          type="password"
          autocomplete="current-password"
          autofocus
        />
        <p v-if="error" class="error-text">{{ error }}</p>
        <button class="button primary" :disabled="loading || !canSubmit">
          {{ loading ? "登录中..." : "登录" }}
        </button>
      </form>
      <div v-else class="empty">
        请在配置文件或环境变量中设置管理密码哈希或 admin token 后重启服务。
      </div>
    </div>
  </section>
</template>

<script setup lang="ts">
import { computed, ref } from "vue";
import { useAuthStore } from "../stores/auth";

const auth = useAuthStore();
const password = ref("");
const token = ref("");
const error = ref("");
const loading = ref(false);
const tokenMode = computed(() => Boolean(auth.security?.bearer_auth_enabled && !auth.security?.password_auth_enabled));
const canSubmit = computed(() => tokenMode.value ? token.value.trim() : password.value);

async function submit() {
  loading.value = true;
  error.value = "";
  try {
    if (tokenMode.value) {
      await auth.loginBearer(token.value.trim());
    } else {
      await auth.login(password.value);
    }
  } catch (err) {
    error.value = err instanceof Error ? err.message : "登录失败";
  } finally {
    loading.value = false;
  }
}
</script>

<style scoped>
.login-page {
  min-height: 100vh;
  display: grid;
  place-items: center;
  background: #101418;
  padding: 24px;
}
.login-panel {
  width: min(420px, 100%);
  border: 1px solid #26313b;
  border-radius: 8px;
  background: #151b21;
  padding: 28px;
}
.login-panel h1 { margin: 24px 0 12px; }
.login-panel form { display: grid; gap: 12px; }
.security-message { color: #b9c4cf; }
.security-message.locked { color: #f3b261; }
</style>
